import React, { useEffect, useState } from 'react';
import {
  Card,
  Row,
  CardTitle,
  CardBody,
  Button,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import { apiService } from '../../constants/ApiService';
import { toast } from 'react-toastify';
import useVendorBranch from '../../utils/useVendorBranch';

const AddEditHostel = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.authState);

  const { isSuperAdmin, isAdmin, hasMultiBranch } = useVendorBranch(user);

  const [hostelData, setHostelData] = useState({
    id: 0,
    vendor_id: 0,
    branch_id: 0,
    hostel_name: '',
    fee_type: '',
    amount: '',
    is_active: true,
  });

  const [errorMessage, setErrorMessage] = useState({});

  useEffect(() => {
    if (location.state) {
      setHostelData((prev) => ({
        ...prev,
        ...location.state,
      }));
    }
  }, [location.state]);

  const onChangeHandle = (e) => {
    const { name, value, type, checked } = e.target;
    setHostelData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const SaveHostel = async () => {
    if (
      isSuperAdmin &&
      (!hostelData.vendor_id || hostelData.vendor_id <= 0)
    ) {
      toast.error('Please select Vendor');
      return;
    }

    if (
      (isSuperAdmin || isAdmin || hasMultiBranch) &&
      (!hostelData.branch_id || hostelData.branch_id <= 0)
    ) {
      toast.error('Please select Branch');
      return;
    }

    if (!hostelData.hostel_name) {
      toast.error('Please enter Hostel Name');
      return;
    }

    if (!hostelData.amount) {
      toast.error('Please enter Amount');
      return;
    }

    try {
      let res;

      if (hostelData.id && hostelData.id > 0) {
        res = await apiService.put(
          `api/HostelMaster/UpdateHostel?id=${hostelData.id}`,
          hostelData
        );
      } else {
        res = await apiService.post(
          'api/HostelMaster/InsertHostel',
          hostelData
        );
      }

      if (res?.status === true) {
        toast.success(res.message);
        navigate('/list-hostel');
      } else {
        toast.error(res?.message || 'Failed');
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    }
  };

  return (
    <>
      <VendorBranchSelector
        user={user}
        selectionData={hostelData}
        setSelectionData={setHostelData}
        accessButton={true}
        errorMessage={errorMessage}
      />

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='border-bottom p-3 d-flex justify-content-between align-items-center'>
          <span>Hostel Form</span>
          <Button color='warning' onClick={() => navigate(-1)}>
            <i className='bi bi-arrow-left' />
          </Button>
        </CardTitle>

        <CardBody>
          <Row>
            <FormGroup className='col-sm-6'>
              <Label>Hostel Name</Label>
              <Input
                type='text'
                name='hostel_name'
                value={hostelData.hostel_name}
                onChange={onChangeHandle}
              />
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Fee Type</Label>
              <Input
                type='text'
                name='fee_type'
                value={hostelData.fee_type}
                onChange={onChangeHandle}
              />
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Amount</Label>
              <Input
                type='number'
                name='amount'
                value={hostelData.amount}
                onChange={onChangeHandle}
              />
            </FormGroup>

            <FormGroup className='col-sm-6 mt-4'>
              <Label check>
                <Input
                  type='checkbox'
                  name='is_active'
                  checked={!!hostelData.is_active}
                  onChange={onChangeHandle}
                />{' '}
                Active
              </Label>
            </FormGroup>
          </Row>

          <Button
            color='primary'
            className='float-end mt-3'
            onClick={SaveHostel}
          >
            Save
          </Button>
        </CardBody>
      </Card>
    </>
  );
};

export default AddEditHostel;
